import { render, staticRenderFns } from "./MarkerInfoWindowDetails.vue?vue&type=template&id=587638d0&scoped=true"
import script from "./MarkerInfoWindowDetails.vue?vue&type=script&lang=ts"
export * from "./MarkerInfoWindowDetails.vue?vue&type=script&lang=ts"
import style0 from "./MarkerInfoWindowDetails.vue?vue&type=style&index=0&id=587638d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587638d0",
  null
  
)

export default component.exports